var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-10 is-offset-1"},[_c('span',{staticClass:"card-title"},[_vm._v("Antworten")]),_c('div',{attrs:{"id":"echartsRadar"}})])])
}]

export { render, staticRenderFns }